export interface BrandMarkProps {
  /** Rendered size in pixels. */
  size?: number;
  /** An accessible name. Without one the mark is decorative, which it is wherever the product name is beside it. */
  title?: string;
}

/**
 * The Daghfal mark — the little elephant of design/brand/assets/mark.svg — drawn in `currentColor`, so the
 * brand square around it decides the colours (`--dg-app-icon-bg` / `--dg-app-icon-fg`, one pair per app).
 *
 * Below 32px it draws mark-small.svg instead, whose eyes and trunk are heavier so that they survive the size
 * (design/brand/identity-page.html §02).
 */
export function BrandMark({ size = 24, title }: BrandMarkProps) {
  const small = size < 32;
  return (
    <svg
      className="dg-brand-mark"
      viewBox="0 0 120 120"
      width={size}
      height={size}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {small ? (
        <>
          <path d="M40 34C18 30 2 44 4 62s21 29 36 21z" fill="currentColor" />
          <path d="M80 34c22-4 38 10 36 28s-21 29-36 21z" fill="currentColor" />
          <path
            d="M60 10c-17 0-26 12-26 28v18c0 16 11 28 26 28s26-12 26-28V38c0-16-9-28-26-28zM40 51a6 6 0 1 0 12 0a6 6 0 1 0-12 0zM68 51a6 6 0 1 0 12 0a6 6 0 1 0-12 0z"
            fill="currentColor"
            fillRule="evenodd"
          />
          <path d="M60 74c2 18-3 29-12 28-7-1-9-8-3-11" fill="none" stroke="currentColor" strokeWidth="15" strokeLinecap="round" />
        </>
      ) : (
        <>
          <path d="M42 34C20 29 3 43 5 62s21 30 37 22z" fill="currentColor" />
          <path d="M78 34c22-5 39 9 37 28s-21 30-37 22z" fill="currentColor" />
          <path
            d="M60 10c-16 0-25 12-25 27v19c0 16 11 28 25 28s25-12 25-28V37c0-15-9-27-25-27zM44.4 52a4.6 4.6 0 1 0 9.2 0a4.6 4.6 0 1 0-9.2 0zM66.4 52a4.6 4.6 0 1 0 9.2 0a4.6 4.6 0 1 0-9.2 0z"
            fill="currentColor"
            fillRule="evenodd"
          />
          <path d="M60 74c2 19-3 30-12 29-7-1-10-8-4-12" fill="none" stroke="currentColor" strokeWidth="13" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}
